import React from 'react';
import { Link } from 'react-router-dom';
import PdButton from 'components/pd-button';
import { Col, Row, Layout } from 'antd';

import './style.scss';
const { Content } = Layout;

const items = [
  {
    title: 'Terms and Conditions',
    pathname: '/terms_and_conditions/terms',
  },
  {
    title: 'Rent Terms and Conditions',
    pathname: '/terms_and_conditions/rent_terms',
  },
  {
    title: 'Business Terms and Conditions',
    pathname: '/terms_and_conditions/business_terms',
  },
  {
    title: 'Privacy Policy',
    pathname: '/terms_and_conditions/privacy_policy',
  },
];
export function TermsAndConditions() {
  return (
    <Layout className="pd-cms-terms-policy main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">Terms and Policy</div>
          <Content className="pageContent">
            {items.map((item, index) => (
              // eslint-disable-next-line react/jsx-key
              <div key={index} className="item">
                <Row gutter={20}>
                  <Col span={24}>
                    <Row type="flex" align="middle" gutter={30}>
                      <Col span={11}>
                        <div className="table-title--sort">{item.title}</div>
                      </Col>
                      <Col span={8} />
                      <Col span={4}>
                        <div className="button-table">
                          <Row className="button">
                            <Link to={item.pathname}>
                              <PdButton type="primary" full>
                                Edit
                              </PdButton>
                            </Link>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            ))}
          </Content>
        </div>
      </div>
    </Layout>
  );
}

export default { TermsAndConditions };
